module.exports = __webpack_public_path__ + "static/media/glyph-creative.5f753cf4.svg";